import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipComponent',
  props: {
  tooltipText: String,
  tooltipLink: {
    type: String,
    required: false
  },
  text: {
    type: String,
    required: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();


const props = __props;

const onLinkClick = () => {
  if(props.tooltipLink) {
    window.open(props.tooltipLink, '_blank');
  }

};

const __returned__ = { props, onLinkClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})